export enum RequestStatus{
    NotOpened = 1,
    Canceled,
    Approved,
    Rejected,
    Error
}